import { tokens } from '@pacevault/ui/lib/tokens.ts';
import type { StudioRouteColor } from '@/types.ts';

interface RouteColorValue {
  rgb: [number, number, number];
  hex: string;
}

export const COLORS_BY_STUDIO_ROUTE_COLOR: Record<StudioRouteColor, RouteColorValue> = {
  fuchsia: { rgb: [232, 121, 249], hex: tokens.routeFuchsia },
  emerald: { rgb: [52, 211, 153], hex: tokens.routeEmerald },
  amber: { rgb: [251, 191, 36], hex: tokens.routeAmber },
  violet: { rgb: [167, 139, 250], hex: tokens.routeViolet },
  orange: { rgb: [249, 115, 22], hex: tokens.routeOrange },
  rose: { rgb: [251, 113, 133], hex: tokens.routeRose },
};

export const routeColorOrder = Object.keys(COLORS_BY_STUDIO_ROUTE_COLOR) as StudioRouteColor[];

export const nextRouteColor = (used: StudioRouteColor[]): StudioRouteColor => {
  const counts = new Map<StudioRouteColor, number>();
  for (const color of used) counts.set(color, (counts.get(color) ?? 0) + 1);

  let next = routeColorOrder[0] as StudioRouteColor;
  for (const color of routeColorOrder) {
    if ((counts.get(color) ?? 0) < (counts.get(next) ?? 0)) next = color;
  }
  return next;
};
